module.exports = __webpack_public_path__ + "static/img/theatre_4.f280452.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/theatre_4.jpg
// module id = aru1
// module chunks = 3